<div class="page-body">
    <div class="row"> 

      <div class="col-lg-12 col-md-12">
        <app-card [title]="''" align="center">
          <img src="assets/images/grafico.jpg" alt="" width="65%">
        </app-card>
      </div> 
  
    </div>
  </div>
  